export default "__VITE_ASSET__f9946dca__"